import { ISanitizeProps, IValidator } from 'src/validators/interface/Validator';
import { ValidationError } from 'yup';
import { ISchema } from './interface/Schema';

class Validator implements IValidator {
  private readonly _schema: ISchema;
  constructor(schema: ISchema) {
    this._schema = schema;
  }

  public isValid<T>(data: T) {
    return this._schema.isValidSync(data);
  }

  public sanitize<T, P>({ data, defaultValues }: ISanitizeProps<T, P>) {
    if (!data) {
      return { ...defaultValues };
    }

    const definedData = this._schema.cast(data, {
      assert: false,
    }) as T;
    try {
      this._schema.validateSync(definedData, {
        abortEarly: false,
      });
    } catch (err) {
      if (err instanceof ValidationError) {
        err.inner.forEach((err) => {
          if (err.path) {
            definedData[err.path] = defaultValues?.[err.path];
          }
        });
      }
    }
    return definedData as T;
  }
}

export default Validator;
